import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import NoResultsFoundImg from "../../../assets/images/No-resultz-Found.png";
import { cancelSubscription, getActiveSubscriptions } from "../../../redux/features/subscription/subscriptionServices";
import BeatLoader from "react-spinners/BeatLoader";
import { showToast } from "../../../components/ToastMsg";
import CardSekeleton from "../../../components/Skeleton/CardSekeleton";
import Modal from "../../../components/Modal";
import { faCheckCircle, faCircleCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const MySubscriptions = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isSubscriptionsLoading, subscriptions } = useSelector((state) => state.subscription.activeSubscriptions);
  const { isCancelling } = useSelector((state) => state.subscription.removeSubscription);

  const [cancellingId, setCancellingId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [isParam, setParam] = useState({ statusCode: '', message: '' });
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    dispatch(getActiveSubscriptions());
  }, [dispatch]);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const statusCode = queryParams.get("status_code");
    const message = queryParams.get("message");
    setParam({
      statusCode: statusCode,
      message: message
    });
    if (statusCode === '0') {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const url = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, url);
    }, 3000); // 3000ms = 3 seconds

    return () => clearTimeout(timer); // cleanup if component unmounts
  }, []);

  const cancelSelectedSubscription = async () => {
    setModalOpen(false);
    setCancellingId(selectedSubscription.id);
    try {
      const data = {
        subscription_id: selectedSubscription.id
      }
      const response = await dispatch(cancelSubscription(data)).unwrap();
      if (response.subscription_status === 'Cancelled') {
        showToast('success', 'Your subscription has been successfully cancelled.');
        dispatch(getActiveSubscriptions());
        setCancellingId(null);
      }
    } catch (error) {
      showToast('error', error.message);
      setCancellingId(null);
    }
  }

  return (
    <div className={styles.myTicketsContainer}>
      <div className={`main-container`}>
        <div className={`container-content`}>
          <div className={styles.myTicketsSubContainer}>
            <div className={styles.homeHeader}>
              <h1 className={styles.title}>{(isSubscriptionsLoading || subscriptions?.length > 0) && `${t(`Subscription`)}`}</h1>
            </div>
            {
              <div className={styles.ticketList}>
                {isSubscriptionsLoading ?
                  Array.from({ length: 2 }).map((_, index) => (
                    <div className={styles.ticketCard}>
                      <div className={styles.ticketCardBody}>
                        <CardSekeleton key={index} />
                      </div>
                    </div>
                  ))
                  : subscriptions?.length > 0 ?
                    subscriptions.map((subscription) => {
                      const lotteryName = subscription?.lottery_brand?.name;
                      const logoUrl = subscription?.lottery_brand?.logo_url;
                      return (
                        subscription && (
                          <div key={subscription.id} className={styles.ticketCard}>
                            <div className={styles.ticketCardBody}>
                              <div className={styles.ticketDetails}>
                                <img
                                  src={logoUrl}
                                  alt="Lottery Logo"
                                  className={styles.logo}
                                />
                                <div className={styles.lotteryName}>
                                  {lotteryName}
                                </div>
                              </div>
                              <div className={styles.priceColumn}>
                                <div className={styles.winningPrice}>
                                  {t(`Recurrence`)}
                                </div>
                                <div className={styles.winningPriceValue}>
                                  {subscription.subscription_type}
                                </div>
                              </div>
                              <div className={styles.priceColumn}>
                                <div className={styles.winningPrice}>
                                  {t(`Duration`)}
                                </div>
                                <div className={styles.winningPriceValue}>
                                  {subscription.duration_type}
                                </div>
                              </div>
                              <div className={styles.priceColumn}>
                                <div className={styles.winningPrice}>
                                  {t(`Quantity`)}
                                </div>
                                <div className={styles.winningPriceValue}>
                                  {subscription.quantity}
                                </div>
                              </div>
                              <div className={styles.priceColumn}>
                                <div className={styles.winningPrice}>
                                  {t(`Amount`)}
                                </div>
                                <div className={styles.winningPriceValue}>
                                  {t(`Rs`)} {subscription.amount.toFixed(2)}
                                </div>
                              </div>
                            </div>
                            <div className={styles.ticketCardFooter}>
                              <button
                                className={`primary-btn ${styles.purchaseBtn}`}
                                onClick={() => {
                                  setSelectedSubscription(subscription);
                                  setModalOpen(true);
                                }}
                                disabled={cancellingId === subscription.id}>
                                {cancellingId === subscription.id ? <BeatLoader color="#FFFFFF" /> : `${t(`Cancel Subscription`)}`} </button>
                            </div>
                          </div>
                        )
                      );
                    })
                    : <div className={styles.noResults}>
                      <img
                        src={NoResultsFoundImg}
                        alt="No Results Found"
                        className={styles.noResultsImage}
                      />
                    </div>
                }
              </div>
            }
            {modalOpen &&
              <Modal
                title='Cancel Subscription'
                onClose={() => setModalOpen(false)}
                onYes={cancelSelectedSubscription}
                isInput={false}
                iconName={faCircleCheck}
                bodyText={`Are you sure you want to cancel the subscription?`}
                colorType={`var(--primary)`}
              />
            }
             {isOpen &&
                <>
                    <div className={styles.modal}>
                        <div className={styles.modalContainer}>
                            <div className={styles.closeRow}>
                                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                    setOpen(false);
                                    document.body.style.overflow = 'unset';
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }} />
                            </div>
                            <div className={styles.modalBody}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkIcon}/>
                                        <p className={styles.conTitle}>Subscription Succeed</p>
                                        <p className={styles.conText}>Your subscription has been successfully completed.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySubscriptions;
